export interface IDeviceMetadata {
  sensorType?: string
  latitude?: string | null
  longitude?: string | null
  interfaceId?: string | number
  type?: string
  source?: string
  [key: string]: any
}

export interface IDevice {
  description: string
  id: number
  metadata: IDeviceMetadata
}
export interface IAsset {
  description: string
  id: number
  metadata: any
  name: string
  parentId: number
  topicName: string
  type: string
}

export interface IUpdateAsset {
  name: string
  description?: string
  metadata?: any
  type: string
}

export interface IPayloadGetTagLatestValue {
  assetId: number
  tags: string[]
}

export enum AssetType {
  PressureSensor = 'Pressure Sensor',
  TankLevelSensor = 'Tank Level Sensor',
  FlowSensor = 'Flow Sensor',
  SoilSensor = 'Soil Sensor',
  PitchQuality = 'Pitch Quality',
  RainSensor = 'Rain Sensor',
  WeatherStation = 'WeatherStation',
  Other = 'Other',
}
